export default __webpack_public_path__ + "static/news-img3-7e5af4563e4ecf99f416d86fcfbc8b98.jpg";